import { render, staticRenderFns } from "./orderModuleTitle.vue?vue&type=template&id=1dae6649&scoped=true"
import script from "./orderModuleTitle.vue?vue&type=script&lang=js"
export * from "./orderModuleTitle.vue?vue&type=script&lang=js"
import style0 from "./orderModuleTitle.vue?vue&type=style&index=0&id=1dae6649&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae6649",
  null
  
)

export default component.exports